import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useFinchStatus() {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState();

  useEffect(() => {
    axios
      .get(routes.api.managers.finch.status)
      .then((response) => {
        setStatus(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, status };
}
